export const BASE_URL = 'https://localhost:3000'
export const ROUTES = {
  LOGIN: '/taskpane.html',
  SHORTLIST: '/shortlist.html',
  NOTEMAIL: '/email.html',
  SUCCESS: '/success.html',
  ACCOMMODATION: '/accommodation.html',
  MFA: '/mfa.html',
  INCOMPATIBLE_EMAIL: '/incompatible-email.html',
  HOUSING_REQUEST: '/housing-request.html',
}

export type RoutesType = (typeof ROUTES)[keyof typeof ROUTES]

export function redirect(url: string) {
  window.location.href = `${BASE_URL}${url}`
}
